export default {
  'en': 'English - Global',
  'en_au': 'English - Australian',
  'en_uk': 'English - UK',
  'en_us': 'English - US',
  'es': 'Spanish',
  'fr': 'French',
  'de': 'German',
  'it': 'Italian',
  'pt': 'Portuguese',
  'nl': 'Dutch',
  'hi': 'Hindi',
  'ja': 'Japanese',
  'zh': 'Chinese',
  'fi': 'Finnish',
  'ko': 'Korean',
  'pl': 'Polish',
  'ru': 'Russian',
  'tr': 'Turkish',
  'uk': 'Ukrainian',
  'vi': 'Vietnamese',
  'af': 'Afrikaans',
  'sq': 'Albanian',
  'am': 'Amharic',
  'ar': 'Arabic',
  'hy': 'Armenian',
  'as': 'Assamese',
  'az': 'Azerbaijani',
  'ba': 'Bashkir',
  'eu': 'Basque',
  'be': 'Belarusian',
  'bn': 'Bengali',
  'bs': 'Bosnian',
  'br': 'Breton',
  'bg': 'Bulgarian',
  'ca': 'Catalan',
  'hr': 'Croatian',
  'cs': 'Czech',
  'da': 'Danish',
  'et': 'Estonian',
  'fo': 'Faroese',
  'gl': 'Galician',
  'ka': 'Georgian',
  'el': 'Greek',
  'gu': 'Gujarati',
  'ht': 'Haitian',
  'ha': 'Hausa',
  'haw': 'Hawaiian',
  'he': 'Hebrew',
  'hu': 'Hungarian',
  'is': 'Icelandic',
  'id': 'Indonesian',
  'jw': 'Javanese',
  'kn': 'Kannada',
  'kk': 'Kazakh',
  'lo': 'Lao',
  'la': 'Latin',
  'lv': 'Latvian',
  'ln': 'Lingala',
  'lt': 'Lithuanian',
  'lb': 'Luxembourgish',
  'mk': 'Macedonian',
  'mg': 'Malagasy',
  'ms': 'Malay',
  'ml': 'Malayalam',
  'mt': 'Maltese',
  'mi': 'Maori',
  'mr': 'Marathi',
  'mn': 'Mongolian',
  'ne': 'Nepali',
  'no': 'Norwegian',
  'nn': 'Norwegian Nynorsk',
  'oc': 'Occitan',
  'pa': 'Panjabi',
  'ps': 'Pashto',
  'fa': 'Persian',
  'ro': 'Romanian',
  'sa': 'Sanskrit',
  'sr': 'Serbian',
  'sn': 'Shona',
  'sd': 'Sindhi',
  'si': 'Sinhala',
  'sk': 'Slovak',
  'sl': 'Slovenian',
  'so': 'Somali',
  'su': 'Sundanese',
  'sw': 'Swahili',
  'sv': 'Swedish',
  'tl': 'Tagalog',
  'tg': 'Tajik',
  'ta': 'Tamil',
  'tt': 'Tatar',
  'te': 'Telugu',
  'tk': 'Turkmen',
  'ur': 'Urdu',
  'uz': 'Uzbek',
  'cy': 'Welsh',
  'yi': 'Yiddish',
  'yo': 'Yoruba'
};